import React from 'react';
import { Box } from '@mui/material';
import { WithTranslation, withTranslation } from 'react-i18next';

import { useStyles } from './styles';

const UserTag = ({ t: translate }: WithTranslation) => {
  const classes = useStyles();

  return (
    <Box component="span" sx={classes.tag}>
      {translate('userTag')}
    </Box>
  );
};

export default withTranslation()(UserTag);
